/* Menú móvil */
(function () {
  'use strict';
  function bind() {
    document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
      if (btn.__bb) return; btn.__bb = true;
      var menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (!menu) return;
      btn.addEventListener('click', function () { menu.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; });
      menu.querySelectorAll('[data-menu-close], a').forEach(function (c) {
        c.addEventListener('click', function () { menu.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', bind);
})();

/* Galería: «imagen 1» va de fondo en Calor + masaje, «imagen 3» se quita (repetida) y «catira sofá» va de las últimas */
(function () {
  var car = document.querySelector('[data-car]');
  if (!car) return;
  ['relleno-1', 'relleno-3'].forEach(function (k) {
    var s = car.querySelector('.bb-car__slide[data-key="' + k + '"]');
    if (s) s.parentNode.removeChild(s);
  });
  var first = car.querySelector('.bb-car__slide');
  if (first && !car.querySelector('[data-key="catira-sofa"]')) {
    var n = first.cloneNode(true);
    n.setAttribute('data-key', 'catira-sofa');
    var im = n.querySelector('img');
    im.src = 'https://cdn.shopify.com/s/files/1/1028/7867/5270/files/catira-sofa.jpg?width=900';
    im.alt = 'Mujer en el sofá con el cinturón';
    im.setAttribute('loading', 'lazy');
    car.appendChild(n);
  }
  var c = document.querySelector('[data-car-count]');
  if (c) c.textContent = '1 / ' + car.querySelectorAll('.bb-car__slide').length;
})();

/* Estilo general */
(function () {
  var BASE = 'linear-gradient(180deg,rgba(255,255,255,0) 0%,rgba(255,255,255,.09) 22%,rgba(255,255,255,0) 50%,rgba(35,12,20,.05) 78%,rgba(35,12,20,0) 100%)';
  var st = document.createElement('style');
  st.textContent = '#comprar .belt-title--top{padding:0!important;font-size:min(5.5vw,32px)!important;white-space:nowrap;line-height:1.15}.belt-cart-btn{top:6px!important;right:10px!important}.bb-brand__text,.bb-brand__text:hover{text-decoration:none!important}'
    + '.bb-brand__text{display:inline-flex;align-items:center}.maror-logo{display:block;height:38px;width:auto}'
    + '@media(min-width:900px){#comprar .belt-title--top{font-size:34px!important;white-space:normal}}'
    + 'main .shopify-section>section:not(.bh){background-image:' + BASE + '!important}'
    + 'main .shopify-section h2::after{content:"";display:block;width:38px;height:2px;margin:12px auto 0;background:var(--c-accent);border-radius:2px}'
    + '.bh__title::after{background:rgba(255,255,255,.75)!important}.bs__title::after,.bc__title::after,.bg2__title::after{margin-left:auto;margin-right:auto}.bg2__title::after{margin-left:0}'
    + '#comprar .bb-cards{gap:6px}#comprar .bb-card__ui{padding:8px 12px;gap:8px;border-radius:12px}#comprar .bb-card__name{font-size:14px}#comprar .bb-card__sub{font-size:11px;margin-top:1px}#comprar .bb-card__price{font-size:14px}'
    + '#comprar .bb-step{margin-bottom:8px}#comprar .bb-step legend{font-size:14px;margin-bottom:6px}#comprar .belt-gift__list{gap:4px}#comprar .belt-gift__opt{padding:5px 8px;font-size:12px;border-radius:10px}.belt-aroma__img{width:26px!important;height:26px!important}'
    + '#comprar .btn{min-height:44px;font-size:14.5px}#comprar .bb-dot__ui{width:24px;height:24px}'
    + '#comprar .bb-pay{margin:12px 0 0}#comprar .belt-aviso{margin:10px 0 0}'
    + '#comprar .bb-badges{display:flex!important;flex-wrap:wrap;justify-content:space-between;gap:8px 4px!important;margin:12px 0 0!important;padding:0!important}'
    + '#comprar .bb-badges li{display:flex!important;flex-direction:row!important;align-items:center;gap:5px;padding:0!important;border:0!important;background:transparent!important;border-radius:0!important;box-shadow:none!important;font-size:11px!important;font-weight:600;white-space:nowrap;line-height:1.2;flex:0 0 auto}#comprar .bb-badges li::before{display:none!important}'
    + '#comprar .bb-badges svg{flex:0 0 auto;width:15px;height:15px;stroke:#7A2E3F;fill:none;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round}';
  document.head.appendChild(st);
  var ICONS = {
    desistir: '<path d="M4 12a8 8 0 1 0 2.6-5.9"/><path d="M4 4v4h4"/>',
    garantia: '<path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/>',
    pago: '<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
    atencion: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/>'
  };
  function badges() {
    document.querySelectorAll('.bb-badges li').forEach(function (li) {
      if (li.querySelector('svg')) return;
      var t = li.textContent.toLowerCase(), k = /desist|devol/.test(t) ? 'desistir' : /garant/.test(t) ? 'garantia' : /pago|seguro/.test(t) ? 'pago' : /atenci|email|correo/.test(t) ? 'atencion' : 'garantia';
      li.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 24 24" aria-hidden="true">' + ICONS[k] + '</svg>');
    });
    var av = document.querySelector('#comprar .belt-aviso'), pay = document.querySelector('#comprar .bb-pay');
    if (av && pay) pay.insertAdjacentElement('afterend', av);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', badges); else badges();
  window.__belt_base = BASE;
})();

/* Uniones entre secciones: franja corta (14 px); «Calor + masaje» lleva ondas suaves arriba (color de arriba) y abajo (color de abajo) */
(function () {
  var FADE = 14, WAVE = 40;
  function solid(el) {
    var c = getComputedStyle(el).backgroundColor;
    return (c && c !== 'rgba(0, 0, 0, 0)' && c !== 'transparent') ? c : null;
  }
  function band(color, dir, h) { return 'linear-gradient(' + dir + ',' + color + ' 0,rgba(0,0,0,0) ' + h + 'px)'; }
  function wave(color, top) {
    var d = top
      ? 'M0,0 L1200,0 L1200,30 C1000,44 800,44 600,30 C400,16 200,16 0,30 Z'
      : 'M0,64 L1200,64 L1200,34 C1000,20 800,20 600,34 C400,48 200,48 0,34 Z';
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 64" preserveAspectRatio="none"><path d="' + d + '" fill="' + color + '"/></svg>';
    return 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';
  }
  function run() {
    var BASE = window.__belt_base;
    var secs = [].slice.call(document.querySelectorAll('main .shopify-section > section'));
    secs.forEach(function (el, i) {
      var prev = secs[i - 1], next = secs[i + 1];
      var isHero = el.classList.contains('bh');
      var pc = prev && !prev.classList.contains('bh') ? solid(prev) : null;
      var nc = next && !next.classList.contains('bh') ? solid(next) : null;
      if (isHero) {
        var layers = [], sizes = [], pos = [];
        if (pc) { layers.push(wave(pc, true)); sizes.push('101% ' + WAVE + 'px'); pos.push('center -1px'); }
        if (nc) { layers.push(wave(nc, false)); sizes.push('101% ' + WAVE + 'px'); pos.push('center calc(100% + 1px)'); }
        if (!layers.length) return;
        var orig = el.style.backgroundImage;
        el.style.setProperty('background-image', layers.join(',') + ',' + orig, 'important');
        el.style.setProperty('background-size', sizes.join(',') + ',cover,cover', 'important');
        el.style.setProperty('background-position', pos.join(',') + ',center,center', 'important');
        el.style.setProperty('background-repeat', 'no-repeat', 'important');
        /* solapar 1 px con los vecinos para que no quede ninguna línea por redondeo de píxeles */
        var hs = el.closest('.shopify-section'); if (hs) hs.style.marginTop = '-1px';
        var ns = next && next.closest('.shopify-section'); if (ns) ns.style.marginTop = '-1px';
        return;
      }
      if (!pc) return;
      el.style.setProperty('background-image', band(pc, 'to bottom', FADE) + ',' + BASE, 'important');
      el.style.setProperty('background-size', '100% ' + FADE + 'px,100% 100%', 'important');
      el.style.setProperty('background-position', 'top,0 0', 'important');
      el.style.setProperty('background-repeat', 'no-repeat', 'important');
    });
  }
  if (document.readyState === 'complete') run(); else window.addEventListener('load', run);
})();

/* Logo Marora: «logo página» en la cabecera y «logo web» como icono de la pestaña */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/1028/7867/5270/files/';
  function put() {
    var a = document.querySelector('.bb-brand__text');
    if (a && !a.querySelector('.maror-logo')) {
      a.innerHTML = '<img class="maror-logo" src="' + CDN + 'logo-pagina.png" alt="Marora" width="150" height="38">';
    }
    document.querySelectorAll('link[rel~="icon"],link[rel="shortcut icon"],link[rel="apple-touch-icon"]').forEach(function (l) { l.parentNode.removeChild(l); });
    var l = document.createElement('link'); l.rel = 'icon'; l.type = 'image/png'; l.href = CDN + 'logo-web.png';
    document.head.appendChild(l);
    var t = document.createElement('link'); t.rel = 'apple-touch-icon'; t.href = CDN + 'logo-web.png';
    document.head.appendChild(t);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', put); else put();
})();

/* Galería: respaldo del scroll suave (algunos navegadores no animan) */
(function () {
  var orig = Element.prototype.scrollTo;
  Element.prototype.scrollTo = function (a) {
    var el = this;
    orig.apply(el, arguments);
    if (el.classList && el.classList.contains('bb-car') && a && a.behavior === 'smooth' && typeof a.left === 'number') {
      setTimeout(function () {
        if (Math.abs(el.scrollLeft - a.left) > 2) {
          el.style.scrollSnapType = 'none'; el.scrollLeft = a.left;
          setTimeout(function () { el.style.scrollSnapType = ''; }, 60);
        }
      }, 500);
    }
  };
})();